const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconTuitionArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.469 392.469",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M292.505,77.059h-59.669c-6.012,0-10.925-4.848-10.925-10.925V21.786H111.042 c-6.012,0-10.925,4.848-10.925,10.925v146.101h192.388L292.505,77.059L292.505,77.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M221.588,43.572h-99.685v135.24h148.816V82.036l-6.4-5.042h-31.418 c-6.012,0-10.925-4.848-10.925-10.925V43.83L221.588,43.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M359.802,200.598H32.691c-6.335,0-11.572,5.107-10.667,13.317l33.552,148.364 c1.164,5.042,5.495,8.469,10.667,8.469h260.202c5.107,0,9.503-3.491,10.667-8.469l33.487-148.299 C371.891,206.287,366.525,200.598,359.802,200.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M46.396,222.384l10.279,45.511h54.303c6.012,0,10.925,4.849,10.925,10.925 c0,6.012-4.848,10.925-10.925,10.925h-49.39l5.495,24.372H86.8c6.012,0,10.925,4.849,10.925,10.925 c0,6.012-4.848,10.925-10.925,10.925H72.061l2.909,13.059h242.812l28.444-126.643H46.396z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M141.491,72.339h44.735c6.012,0,10.925-4.848,10.925-10.925s-4.848-10.925-10.925-10.925h-44.671 c-6.012,0-10.925,4.848-10.925,10.925S135.414,72.339,141.491,72.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M251.131,96.259h-109.64c-6.012,0-10.925,4.848-10.925,10.925c0,6.012,4.848,10.925,10.925,10.925 h109.64c6.012,0,10.925-4.848,10.925-10.925C261.992,101.172,257.143,96.259,251.131,96.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M251.131,142.093h-109.64c-6.012,0-10.925,4.848-10.925,10.925s4.848,10.925,10.925,10.925h109.64 c6.012,0,10.925-4.848,10.925-10.925S257.143,142.093,251.131,142.093z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M78.267,100.59H65.143c-6.012,0-10.925,4.848-10.925,10.925v67.297h24.113V100.59H78.267z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "243.762,33.293 243.762,55.273 271.818,55.273 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M314.291,178.812h24.436v-30.319c0-6.012-4.848-10.925-10.925-10.925h-13.511V178.812 L314.291,178.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M360.513,178.877v-30.384c0-18.036-14.675-32.711-32.711-32.711h-13.511V76.735 c0-10.149-4.59-19.523-12.541-25.729L245.442,6.982C239.754,2.521,232.513,0,225.273,0h-114.36 C92.877,0,78.202,14.675,78.202,32.711v46.028H65.079c-18.036,0-32.711,14.675-32.711,32.711v67.362 c-20.428,1.293-36.073,17.519-31.547,39.887l33.358,148.299c3.426,14.998,16.549,25.471,31.935,25.471h260.202 c15.386,0,28.509-10.537,31.935-25.471l33.487-148.299C395.939,197.56,380.554,179.265,360.513,178.877z M314.291,137.632h13.511 c6.012,0,10.925,4.848,10.925,10.925v30.255h-24.436V137.632L314.291,137.632z M243.762,33.293l28.057,21.915h-28.057V33.293z  M100.117,32.711c0-6.012,4.848-10.925,10.925-10.925h110.933v44.347c0,6.012,4.848,10.925,10.925,10.925h59.669v101.754H100.117 V32.711L100.117,32.711z M54.154,111.515c0-6.012,4.848-10.925,10.925-10.925h13.188v78.287H54.154V111.515z M370.469,213.98 l-33.487,148.299c-1.164,5.042-5.495,8.469-10.667,8.469H66.178c-5.107,0-9.503-3.491-10.667-8.469L22.154,213.98 c-0.905-8.21,4.331-13.317,10.667-13.317h327.111C366.525,200.598,371.891,206.287,370.469,213.98z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconTuitionArea);
export default __webpack_public_path__ + "static/media/common_icon_tuition_area.c576b508c97be5c24aa7fd22ca58f377.svg";
export { ForwardRef as ReactComponent };